<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8" >
            <a-form-item :label="$t('label.contracts')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['conCode']" :trigger-change="true" dictCode="efs_md_contract,name,code, del_flag='N'" :placeholder="$t('label.pleaseSelectContract')"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.batch')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['breedBatchCode']" :trigger-change="true" dictCode="efs_md_breed_batch,name,code" :placeholder="$t('label.pleaseSelectBatch')"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.grower')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['farmerCode']" :trigger-change="true" dictCode="efs_md_farmer,name,code,del_flag = 'N'" :placeholder="$t('label.pleaseSelectGrower')" />
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.farms')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['farmCode']" :trigger-change="true" dictCode="sys_depart,depart_name,org_code" :placeholder="$t('label.pleaseSelectFarms')"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="合同数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['conQty']" placeholder="请输入合同数量" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="实际进苗数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['actQty']" placeholder="请输入实际进苗数量" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.unitPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['unitPrice']" :placeholder="$t('label.pleaseEnterTheUnitPrice')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="余额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['balance']" placeholder="请输入余额" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.amount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['amount']" :placeholder="$t('label.pleaseEnterTheAmount')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="累计上缴金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['addAmount']" placeholder="请输入累计上缴金额" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="上缴日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date disabled placeholder="请选择上缴日期" v-decorator="['postDate']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="上缴人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['applicant']" placeholder="请输入上缴人"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
      <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane tab="保证金领用记录" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="efsStlSettleApplyTable.loading"
          :columns="efsStlSettleApplyTable.columns"
          :dataSource="efsStlSettleApplyTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"/>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: 'EfsStdMarginForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    data() {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
        },
        refKeys: ['efsStlSettleApply', ],
        tableKeys:['efsStlSettleApply', ],
        activeKey: 'efsStlSettleApply',
        // efs_stl_settle_apply
        efsStlSettleApplyTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '农场编码',
              key: 'farmCode',
              type: FormTypes.select,
              dictCode:"sys_depart,depart_name,org_code",
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '饲养批次编码',
              key: 'breedBatchCode',
              type: FormTypes.select,
              dictCode:"efs_md_breed_batch,name,code",
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '放养合同号',
              key: 'contractCode',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '养户编码',
              key: 'farmerCode',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '申请类型',
              key: 'applyType',
              type: FormTypes.select,
              dictCode:"sqlx",
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '类型',
              key: 'subType',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '金额',
              key: 'totalAmount',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '记账日期',
              key: 'postDate',
              type: FormTypes.date,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
          ]
        },
        url: {
          add: "/depositRecord/efsStdMargin/add",
          edit: "/depositRecord/efsStdMargin/edit",
          queryById: "/depositRecord/efsStdMargin/queryById",
          efsStlSettleApply: {
            list: '/depositRecord/efsStdMargin/queryEfsStlSettleApplyByMainId'
          },
        }
      }
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：false流程表单 true普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      addBefore(){
        this.form.resetFields()
        this.efsStlSettleApplyTable.dataSource=[]
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        let fieldval = pick(this.model,'conCode','breedBatchCode','farmerCode','farmCode','conQty','actQty','unitPrice','balance','amount','addAmount','postDate','applicant','lastApprover','lastApproveTime','approvalStatus')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.efsStlSettleApply.list, params, this.efsStlSettleApplyTable)
        }
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          efsStlSettleApplyList: allValues.tablesValue[0].values,
        }
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          })
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },
     popupCallback(row){
       this.form.setFieldsValue(pick(row,'conCode','breedBatchCode','farmerCode','farmCode','conQty','actQty','unitPrice','balance','amount','addAmount','postDate','applicant','lastApprover','lastApproveTime','approvalStatus'))
     },

    }
  }
</script>

<style scoped>
</style>